import axios from "axios";
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
const service = axios.create({
    /**
     * 所有接口的请求baseURL，在config/env.js下设置
     * dev.env.js 编译情况下baseURL设置
     * dep.env.js 设置打包baseURL
     */
    baseURL: "http://bigdata.jshks.com/", //线上地址
    // baseURL: "/api", // api 的 base_url 
    // timeout: 5000 // 5000ms请求超时
})
// request 请求拦截器  在请求头中加token
service.interceptors.request.use(
    config => {
        // 判断是否存在token，如果存在的话，则每个http header都加上token
        let token = localStorage.getItem('token')
        if (token) {
            config.data.token = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    });

// response 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // -1 身份验证失败
        if (-3 === res.code) {
            Message({
                message: res.msg,
                type: "error",
            });
            store.commit("SET_IS_LOGIN", false); //修改登录状态
        }
        return response
    })

export default service